import DOMPurify from "isomorphic-dompurify";

/** Sanitize HTML strings before dangerouslySetInnerHTML. */
export function sanitizeHtml(html) {
  if (html == null || html === "") return "";
  return DOMPurify.sanitize(String(html));
}
